import { Routes } from "@angular/Router";
import { LoginComponent } from "./user/login/login.component";
import { RegisterComponent } from "./user/register/register.component";
import { HomeComponent } from "./home/home.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { AuthGuard } from "./auth/auth.guard";
import { VendorComponent } from "./sitemodules/vendors/vendor/vendor.component"
import { MydashboardComponent } from './sitemodules/dashboards/mydashboard/mydashboard.component';
import { AdduserComponent } from "./sitemodules/vendors/adduser/adduser.component";
import { RoleguardServiceGuard } from "./auth/roleguard-service.guard";
import { PurchaseorderComponent } from "./sitemodules/purchase/purchaseorder/purchaseorder.component";
import { AddpurchaseorderComponent } from "./sitemodules/purchase/addpurchaseorder/addpurchaseorder.component";
import { AddpurchaselinesComponent } from "./sitemodules/purchase/addpurchaselines/addpurchaselines.component";
import { SmgmasterComponent } from "./sitemodules/enlistment/smgmaster/smgmaster.component";
import { SsgmasterComponent } from "./sitemodules/enlistment/ssgmaster/ssgmaster.component";
import { VendorregistrationComponent } from "./sitemodules/enlistment/enlistmentforms/vendorregistration/vendorregistration.component";
import { SmgmanufacturerComponent } from "./sitemodules/enlistment/enlistmentforms/smgmanufacturer/smgmanufacturer.component";
import { SmgdealerComponent } from "./sitemodules/enlistment/enlistmentforms/smgdealer/smgdealer.component";
import { SsgdealerComponent } from "./sitemodules/enlistment/enlistmentforms/ssgdealer/ssgdealer.component";
import { SsgcontractorComponent } from "./sitemodules/enlistment/enlistmentforms/ssgcontractor/ssgcontractor.component";
import { EvaluatevendorComponent } from "./sitemodules/evaluation/evaluatevendor/evaluatevendor.component";
import { EvalsmgmanufacturerComponent } from "./sitemodules/evaluation/evalsmgmanufacturer/evalsmgmanufacturer.component";
import { EvalsmgdealerComponent } from "./sitemodules/evaluation/evalsmgdealer/evalsmgdealer.component";
import { EvalssgdealerComponent } from "./sitemodules/evaluation/evalssgdealer/evalssgdealer.component";
import { EvalssgcontractorComponent } from "./sitemodules/evaluation/evalssgcontractor/evalssgcontractor.component";
import { EvalvendregistationComponent } from "./sitemodules/evaluation/evalvendregistation/evalvendregistation.component";
import { VendorscoreComponent } from "./sitemodules/evaluation/vendorscore/vendorscore.component";
import { EnqlistadminComponent } from "./sitemodules/tendering/admin/enqlistadmin/enqlistadmin.component";
import { EnqassignedComponent } from "./sitemodules/tendering/admin/enqassigned/enqassigned.component";
import { PricequoteComponent } from "./sitemodules/tendering/admin/quotesform/pricequote/pricequote.component";
import { TechpriceComponent } from "./sitemodules/tendering/admin/quotesform/techprice/techprice.component";
import { TechquoteComponent } from "./sitemodules/tendering/admin/quotesform/techquote/techquote.component";
import { MdluploadComponent } from "./sitemodules/engineering/admin/mdlupload/mdlupload.component";
import { MdllistComponent } from "./sitemodules/engineering/admin/mdllist/mdllist.component";
import { EnqlistvendorComponent } from "./sitemodules/tendering/vendor/enqlistvendor/enqlistvendor.component";
import { EnqsubmittedComponent } from "./sitemodules/tendering/admin/enqsubmitted/enqsubmitted.component";
import { PricequotevendorComponent } from "./sitemodules/tendering/vendor/quotesformvendor/pricequotevendor/pricequotevendor.component";
import { TechquotevendorComponent } from "./sitemodules/tendering/vendor/quotesformvendor/techquotevendor/techquotevendor.component";
import { TechpricevendorComponent } from "./sitemodules/tendering/vendor/quotesformvendor/techpricevendor/techpricevendor.component";
import { AssigndrawingComponent } from "./sitemodules/engineering/admin/assigndrawing/assigndrawing.component";
import { MdllistvendorComponent } from "./sitemodules/engineering/vendor/mdllistvendor/mdllistvendor.component";
import { SubmitdrawingComponent } from "./sitemodules/engineering/vendor/submitdrawing/submitdrawing.component";
import { SubmitteddrawingsComponent } from "./sitemodules/engineering/vendor/submitteddrawings/submitteddrawings.component";
import { SubmdrawingsadminComponent } from "./sitemodules/engineering/admin/submdrawingsadmin/submdrawingsadmin.component";
import { DrawingcommentsvendorComponent } from "./sitemodules/engineering/vendor/drawingcommentsvendor/drawingcommentsvendor.component";
import { DrawingcommentsadminComponent } from "./sitemodules/engineering/admin/drawingcommentsadmin/drawingcommentsadmin.component";
import { InspectioncallComponent } from "./sitemodules/inspection/inspectioncall/inspectioncall.component";
import { InvoicetrackreqComponent } from "./sitemodules/invoice/invoicetrackreq/invoicetrackreq.component";
import { MessageComponent } from "./sitemodules/Message/message/message.component";
import { TobeevaluatedlistComponent } from "./sitemodules/evaluation/tobeevaluatedlist/tobeevaluatedlist.component";
import { SettingsComponent } from "./user/settings/settings.component";
import { ProfileComponent } from "./user/profile/profile.component";
import { SiteuserComponent } from "./sitemodules/siteuser/siteuserview/siteuser.component";
import { SiteusereditComponent } from "./sitemodules/siteuser/siteuseredit/siteuseredit.component";
import { SiteuseraddComponent } from "./sitemodules/siteuser/siteuseradd/siteuseradd.component";
import { InvoicelistComponent } from "./sitemodules/invoice/invoicelist/invoicelist.component";
import { SubmittedquoteComponent } from "./sitemodules/tendering/vendor/submittedquote/submittedquote.component";
import { InvoiceuploadComponent } from "./sitemodules/invoice/invoiceupload/invoiceupload.component";
import { InspectionlistComponent } from "./sitemodules/inspection/inspectionlist/inspectionlist.component";
import { InvoiceuplodedComponent } from "./sitemodules/invoice/invoiceuploded/invoiceuploded.component";
import { MDCCComponent } from "./sitemodules/inspection/Vendor/mdcc/mdcc.component";
import { PurchaseheaderComponent } from "./sitemodules/engineering/admin/purchaseheader/purchaseheader.component";
import { PurchaselinesComponent } from "./sitemodules/engineering/admin/purchaselines/purchaselines.component";
import { EnlistuserComponent } from "./sitemodules/enlistment/enlistuser/enlistuser.component";
import { AdminnavinvoiceComponent } from "./sitemodules/invoice/adminnavinvoice/adminnavinvoice.component";
import { VendornavinvoiceComponent } from "./sitemodules/invoice/vendornavinvoice/vendornavinvoice.component";
import { PaymentpageComponent } from "./sitemodules/invoice/paymentpage/paymentpage.component";
import { VieworderadminComponent } from "./sitemodules/engineering/admin/vieworderadmin/vieworderadmin.component";
import { ViewordervendorComponent } from "./sitemodules/engineering/vendor/viewordervendor/viewordervendor.component";
import { VendororderComponent } from "./sitemodules/engineering/vendor/vendororder/vendororder.component";
import { ViewinvoicedetailComponent } from "./sitemodules/invoice/viewinvoicedetail/viewinvoicedetail.component";
import { AddtransportdtlsComponent } from "./sitemodules/engineering/admin/addtransportdtls/addtransportdtls.component";
import { from } from "rxjs";
import { AdminmessageComponent } from "./sitemodules/Message/adminmessage/adminmessage.component";
import { VendormessageComponent } from "./sitemodules/Message/vendormessage/vendormessage.component";
import { MessagelistComponent } from "./sitemodules/Message/messagelist/messagelist.component";
import { ResentquoteComponent } from "./sitemodules/tendering/admin/quotesform/resentquote/resentquote.component";
import { ViewwnlistmentComponent } from "./sitemodules/enlistment/enlistmentforms/viewwnlistment/viewwnlistment.component";
import { UploaddataComponent } from "./sitemodules/MasterData/uploaddata/uploaddata.component";
import { GrnformComponent } from "./sitemodules/grn/grnform/grnform.component";
import { GrnlistComponent } from "./sitemodules/grn/grnlist/grnlist.component";
import { CreditmemoComponent } from "./sitemodules/creditmemo/creditmemo/creditmemo.component";
import { CreditmemolinesComponent } from "./sitemodules/creditmemo/creditmemolines/creditmemolines.component";
import { EditroleComponent } from './sitemodules/rolemanagement/editrole/editrole.component';
import { RoleassignmentComponent } from './sitemodules/rolemanagement/roleassignment/roleassignment.component';
import { UserroleComponent } from './sitemodules/rolemanagement/userrole/userrole.component';
import { ViewroleComponent } from './sitemodules/rolemanagement/viewrole/viewrole.component';
import { AssignsurveylinkComponent } from "./sitemodules/vendors/assignsurveylink/assignsurveylink.component";
import { PrescreeningComponent } from "./sitemodules/PreScreening/prescreening/prescreening.component";
import { ProjectinfoComponent } from "./sitemodules/purchase/projectinfo/projectinfo.component";
import { StartSurveyComponent } from "./sitemodules/vendors/StartSurvey/StartSurvey.component";
import { AnswersComponent } from "./sitemodules/PreScreening/answers/answers.component";
export const appRoutes: Routes = [
    { path: 'home', component: HomeComponent },
    { path: 'message', component: MessageComponent, canActivate: [AuthGuard] },
    { path: 'projectdashboard', component: MydashboardComponent, canActivate: [AuthGuard] },
    { path: 'settings', component: SettingsComponent, canActivate: [AuthGuard] },
    { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
    // { path : 'evaluation', component : TobeevaluatedlistComponent,canActivate : [AuthGuard]},
    { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
    { path: 'siteuser', component: SiteuserComponent, canActivate: [AuthGuard] },

    { path: 'editrole/:id', component: EditroleComponent, canActivate: [AuthGuard] },
    { path: 'StartSurvey/:id/:clid/:clip/:re', component: StartSurveyComponent },
    { path: 'StartSurvey/:s/:re', component: StartSurveyComponent },
    { path: 'viewprojectdetails/:projectid', component: ProjectinfoComponent, canActivate: [AuthGuard] },
    { path: 'userroleassignment', component: RoleassignmentComponent , canActivate: [AuthGuard] },
    { path: 'userrole', component: UserroleComponent, canActivate: [AuthGuard] },
    { path: 'viewrole/:id', component: ViewroleComponent, canActivate: [AuthGuard] },

    { path: 'purchase', component: PurchaseorderComponent, canActivate: [AuthGuard] },
    { path: 'addpurchaseorder', component: AddpurchaseorderComponent, canActivate: [AuthGuard] },
    { path: 'createproject', component: AddpurchaseorderComponent, canActivate: [AuthGuard] },
    { path: 'createproject/:projectid/:projectname/:clientname/:desc', component: AddpurchaseorderComponent, canActivate: [AuthGuard] },
    { path: 'addsiteuser', component: SiteuseraddComponent, canActivate: [AuthGuard] },
    { path: 'addpurchaselines', component: AddpurchaselinesComponent, canActivate: [AuthGuard] },
    { path: 'assignvendorclip', component: AddpurchaselinesComponent, canActivate: [AuthGuard] },
    { path: 'assignvendorclip/:projectid/:countryid/:langid', component: AddpurchaselinesComponent, canActivate: [AuthGuard] },
    { path: 'assignvendorclip/:projectid/:countryid/:langid/:set/:num', component: AddpurchaselinesComponent, canActivate: [AuthGuard] },
    { path: 'vendor', component: VendorComponent, canActivate: [RoleguardServiceGuard] },
    { path: 'vendorregistration', component: VendorComponent, canActivate: [AuthGuard] },
    { path: 'prescreening', component: PrescreeningComponent, canActivate: [AuthGuard] },
    { path: 'submitanswers', component: AnswersComponent, canActivate: [AuthGuard] },
    {
        path: 'adduser',
        component: AdduserComponent,
        canActivate: [RoleguardServiceGuard],
        data: {
            expectedRole: 'admin'
        }
    },
    {
        path: 'evaluation',
        component: TobeevaluatedlistComponent,
        //canActivate: [AuthGuard, RoleguardServiceGuard]
    },
    //{ path : 'adduser', component : AdduserComponent,canActivate : [AuthGuard]},
    {
        path: 'register', component: RegisterComponent
    },
    {
        path: 'login', component: LoginComponent
    },
    {
        path: 'enlistsmguser', component: SmgmasterComponent
    },
    {
      path: 'respondentdata', component: SmgmasterComponent
    },
    {
        path: 'enlistssguser', component: SsgmasterComponent
    },
    {
        path: 'enlistvendor', component: EnlistuserComponent
    },
    {
      path: 'assignsurverlink', component: AssignsurveylinkComponent
    },
    {
      path: 'assignsurverlink/:projectid/:countryid/:langid/:target/:opcount', component: AssignsurveylinkComponent
    },
    { path: 'enlistmentform/:stepno', component: VendorregistrationComponent, canActivate: [AuthGuard] },
    // { path : 'smgmanufacturerform', component : SmgmanufacturerComponent,canActivate : [AuthGuard]},
    { path: 'smgmanufacturerform/:stepno', component: SmgmanufacturerComponent, canActivate: [AuthGuard] },
    { path: 'smgdealerform/:stepno', component: SmgdealerComponent, canActivate: [AuthGuard] },
    { path: 'ssgdealerform/:stepno', component: SsgdealerComponent, canActivate: [AuthGuard] },
    { path: 'ssgcontractorform/:stepno', component: SsgcontractorComponent, canActivate: [AuthGuard] },

    { path: 'evaluate/:applicationrefno', component: EvaluatevendorComponent, canActivate: [AuthGuard] },
    { path: 'evaluatesmgmanufacturerform/:stepno/:applicationrefno', component: EvalsmgmanufacturerComponent, canActivate: [AuthGuard] },
    { path: 'evaluatesmgdealerform/:stepno/:applicationrefno', component: EvalsmgdealerComponent, canActivate: [AuthGuard] },
    { path: 'evaluatessgdealerform/:stepno/:applicationrefno', component: EvalssgdealerComponent, canActivate: [AuthGuard] },
    { path: 'evaluatessgcontractorform/:stepno/:applicationrefno', component: EvalssgcontractorComponent, canActivate: [AuthGuard] },
    { path: 'evaluateenlistmentform/:stepno/:applicationrefno', component: EvalvendregistationComponent, canActivate: [AuthGuard] },
    { path: 'evaluationscore/:applicationrefno', component: VendorscoreComponent, canActivate: [AuthGuard] },

    { path: 'enquirylist', component: EnqlistadminComponent, canActivate: [AuthGuard] },
    { path: 'assignedenquiry', component: EnqassignedComponent, canActivate: [AuthGuard] },

    { path: 'sendpricequote/:enquiryid', component: PricequoteComponent, canActivate: [AuthGuard] },
    { path: 'sendtechquote/:enquiryid', component: TechquoteComponent, canActivate: [AuthGuard] },
    { path: 'siteuseredit/:userid', component: SiteusereditComponent, canActivate: [AuthGuard] },
    { path: 'sendpriceandtechquote/:enquiryid', component: TechpriceComponent, canActivate: [AuthGuard] },
    { path: 'sentpricequotes/:enquiryid', component: ResentquoteComponent, canActivate: [AuthGuard] },


    { path: 'uploadmdl', component: MdluploadComponent, canActivate: [AuthGuard] },
    { path: 'mdllist', component: MdllistComponent, canActivate: [AuthGuard] },


    { path: 'enquirydata', component: EnqlistvendorComponent, canActivate: [AuthGuard] },
    { path: 'submittedquotes', component: EnqsubmittedComponent, canActivate: [AuthGuard] },

    { path: 'submitpricequote/:enquiryid', component: PricequotevendorComponent, canActivate: [AuthGuard] },
    { path: 'submittechquote/:enquiryid', component: TechquotevendorComponent, canActivate: [AuthGuard] },
    { path: 'submitpriceandtechquote/:enquiryid', component: TechpricevendorComponent, canActivate: [AuthGuard] },

    { path: 'assigndrawing/:mdlid', component: AssigndrawingComponent, canActivate: [AuthGuard] },

    { path: 'mdlitem', component: MdllistvendorComponent, canActivate: [AuthGuard] },
    { path: 'submitdrawing/:mdlid', component: SubmitdrawingComponent, canActivate: [AuthGuard] },

    { path: 'submitted', component: SubmitteddrawingsComponent, canActivate: [AuthGuard] },
    { path: 'submitteddrawings', component: SubmdrawingsadminComponent, canActivate: [AuthGuard] },

    { path: 'drawingcomments/:drawingid', component: DrawingcommentsvendorComponent, canActivate: [AuthGuard] },
    { path: 'drawcomments/:drawingid', component: DrawingcommentsadminComponent, canActivate: [AuthGuard] },

    { path: 'inspectioncall', component: InspectioncallComponent, canActivate: [AuthGuard] },

    { path: 'invoicetrackreq', component: InvoicetrackreqComponent, canActivate: [AuthGuard] },
    { path: 'invoicelist', component:InvoicelistComponent, canActivate: [AuthGuard] },

    { path: 'smtvendquote', component:SubmittedquoteComponent, canActivate: [AuthGuard] },

    { path: 'invoiceupload', component:InvoiceuploadComponent, canActivate: [AuthGuard] },
    { path: 'invoiceuploaded', component:InvoiceuplodedComponent, canActivate: [AuthGuard] },
    { path: 'inspectionlist', component:InspectionlistComponent, canActivate: [AuthGuard] },

    { path: 'mdcc', component:MDCCComponent, canActivate: [AuthGuard] },
    { path: 'purchaseheader', component:PurchaseheaderComponent, canActivate: [AuthGuard] },
    { path: 'purchaseline', component:PurchaselinesComponent, canActivate: [AuthGuard] },
    { path: 'paidinvoices', component:AdminnavinvoiceComponent, canActivate: [AuthGuard] },
    { path: 'myinvoices', component:VendornavinvoiceComponent, canActivate: [AuthGuard] },
    { path: 'paymentpage', component:PaymentpageComponent, canActivate: [AuthGuard] },

    { path: 'viewpurchaseorder/:orderid', component: VieworderadminComponent, canActivate: [AuthGuard] },
    { path: 'vieworder/:orderid', component: ViewordervendorComponent, canActivate: [AuthGuard] },

    { path: 'grnlist', component:GrnlistComponent, canActivate: [AuthGuard] },
    // { path: 'grnform/:grnid', component: GrnformComponent, canActivate: [AuthGuard] },
    { path: 'grnform/:id', component: GrnformComponent, canActivate: [AuthGuard] },

    { path: 'creditmemo', component:CreditmemoComponent, canActivate: [AuthGuard] },
    { path: 'creditmemolines/:id', component:CreditmemolinesComponent, canActivate: [AuthGuard] },

    { path: 'viewinvoicedetail/:orderid', component: ViewinvoicedetailComponent, canActivate: [AuthGuard] },

    { path: 'orderheader', component:VendororderComponent, canActivate: [AuthGuard] },
    { path: 'addtransportdtls/:orderid', component:AddtransportdtlsComponent, canActivate: [AuthGuard] },
    { path: 'adminmessage', component:AdminmessageComponent, canActivate: [AuthGuard] },
    { path: 'vendormessage', component:VendormessageComponent, canActivate: [AuthGuard] },
    { path: 'messagelist', component:MessagelistComponent, canActivate: [AuthGuard] },
    { path: 'viewenlistment', component:ViewwnlistmentComponent, canActivate: [AuthGuard] },
    { path: 'uploadmasterdata', component:UploaddataComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {path: '**', redirectTo: '/home'}, //wildcardroute
];
